function hasValue(value) {
  return value !== null && value !== undefined && String(value).trim() !== "";
}

function formatReference(reference, prefix, fallbackId) {
  if (hasValue(reference)) return String(reference).trim();
  if (hasValue(fallbackId)) return `${prefix}-${fallbackId}`;
  return `${prefix}-unavailable`;
}

export function getRFQLabel(record) {
  return formatReference(record?.rfq_number, "RFQ", record?.id);
}

export function getPRLabel(record) {
  return formatReference(record?.pr_number, "PR", record?.purchase_requisition_id ?? record?.pr_id ?? record?.id);
}

export function getPOLabel(record) {
  return formatReference(record?.po_number, "PO", record?.id ?? record?.purchase_order_id ?? record?.po_id);
}

export function getDeliveryLabel(record) {
  return formatReference(record?.delivery_number, "DLV", record?.id);
}
